<template lang="pug">
section.intro
  .content
    h1.intro__title {{ $t("promo.intro.title") }}
    .intro__logo
      img(src="~@/assets/images/intro/logo-part-1.png")
      img(src="~@/assets/images/intro/logo-part-2.png")

    .intro__text
      p(v-for="(text, text_id) in $t('promo.intro.text')", :key="text_id") {{ text }}

    scrollactive(:offset="0", :modifyUrl="false")
      MainButton.intro__button.scrollactive-item(link="#rules") {{ $t("promo.intro.button") }}
</template>

<script>
import MainButton from "./common/MainButton";

export default {
  name: "Intro",
  components: {
    MainButton,
  },
};
</script>
